import { api } from "./client";
import type {
  Device,
  Equipment,
  EquipmentCreate,
  EquipmentStats,
  EquipmentSummary,
  EquipmentKind,
  EquipmentUpdate,
} from "@/types";

export const equipmentsApi = {
  /** Onde o ativo está — na planta e, se souberem, no mundo.
   *
   *  Rota separada do update geral porque o editor salva a cada solta do
   *  arrasto: pelo payload grande, duas abas abertas transformariam um
   *  reposicionamento em sobrescrita de cadastro. Passar `null` nos quatro
   *  tira o ativo da planta. */
  async posicionar(
    id: string,
    pos: {
      planta_x: number | null; planta_y: number | null;
      latitude?: number | null; longitude?: number | null;
    },
  ): Promise<Equipment> {
    const { data } = await api.patch<Equipment>(`/equipments/${id}/posicao`, pos);
    return data;
  },

  /**
   * Catálogo de tipos de ativo. Estático e igual pra todo mundo — o
   * cadastro precisa dele antes de qualquer coisa existir.
   */
  async kinds(): Promise<EquipmentKind[]> {
    const { data } = await api.get<EquipmentKind[]>("/equipment-kinds");
    return data;
  },
  async list(params?: {
    tenant_id?: string;
    include_archived?: boolean;
  }): Promise<Equipment[]> {
    const { data } = await api.get<Equipment[]>("/equipments", { params });
    return data;
  },
  async listInSite(siteId: string): Promise<Equipment[]> {
    const { data } = await api.get<Equipment[]>(`/sites/${siteId}/equipments`);
    return data;
  },
  async get(id: string): Promise<Equipment> {
    const { data } = await api.get<Equipment>(`/equipments/${id}`);
    return data;
  },
  async devices(id: string): Promise<Device[]> {
    const { data } = await api.get<Device[]>(`/equipments/${id}/devices`);
    return data;
  },
  async summary(id: string): Promise<EquipmentSummary> {
    const { data } = await api.get<EquipmentSummary>(`/equipments/${id}/summary`);
    return data;
  },
  async stats(id: string, q?: { from?: string; to?: string }): Promise<EquipmentStats> {
    const { data } = await api.get<EquipmentStats>(`/equipments/${id}/stats`, {
      params: q,
    });
    return data;
  },
  async create(payload: EquipmentCreate): Promise<Equipment> {
    const { data } = await api.post<Equipment>("/equipments", payload);
    return data;
  },
  async update(id: string, payload: EquipmentUpdate): Promise<Equipment> {
    const { data } = await api.patch<Equipment>(`/equipments/${id}`, payload);
    return data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/equipments/${id}`);
  },
};
